import { io } from "socket.io-client";

// URLs come from .env.development or .env.production (Vite picks the
// right file based on --mode at build time). Single source for both
// dev and prod — no per-branch baseUrl.js drift.
//
// See azure-pipelines.yml (passes --mode development) and
// azure-pipelines-prod.yml (Vite default is production mode, loads
// .env.production automatically).
export const baseUrl = import.meta.env.VITE_API_URL
export const socketBaseUrl = import.meta.env.VITE_SOCKET_URL

export const socket = io(socketBaseUrl);
